import {
  ClockCircleOutlined,
  FileAddOutlined,
  HeatMapOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { faListCheck, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo } from 'react';
import { RouteObject } from 'react-router-dom';

const SampleSearchIcon = () => (
  <FontAwesomeIcon icon={faUsers} style={{ marginRight: '8px' }} />
);

const WorklistIcon = () => (
  <FontAwesomeIcon icon={faListCheck} style={{ marginRight: '8px' }} />
);

export type RouteType = {
  path: string;
  layoutType: 'type-1' | 'type-2';
  hasLayout: boolean;
  name: string;
  hideInMenu: boolean;
  displaySidebar: boolean;
  displayHeader: boolean;
  isPublic: boolean;
  completePath: string;
  data: any;
  children?: RouteObject[];
  errorElement?: () => React.ReactNode;
  icon?: any;
};

// each route entry has several properties, e.g "path" , isPublic (true=anyone can visit, false= must be logged in)
export const useRoutes = () => {
  const routes: RouteType[] = useMemo(
    () => [
      {
        path: '',
        layoutType: 'type-1',
        hasLayout: false,
        name: 'Landing',
        hideInMenu: true,
        displaySidebar: false,
        displayHeader: false,
        isPublic: true,
        completePath: '/',
        data: undefined,
      },
      {
        path: '/variant-check',
        layoutType: 'type-1',
        hasLayout: true,
        name: 'Variant search',
        hideInMenu: false,
        displaySidebar: true,
        displayHeader: true,
        // Make variant-check private; only the root landing page should be public
        isPublic: false,
        completePath: '/variant-check',
        data: undefined,
        icon: SearchOutlined,
      },
      {
        path: '/worklist',
        layoutType: 'type-1',
        hasLayout: true,
        name: 'Worklist',
        hideInMenu: false,
        displaySidebar: true,
        displayHeader: true,
        isPublic: false,
        completePath: '/worklist',
        data: undefined,
        icon: WorklistIcon,
      },
      {
        path: '/dashboard',
        layoutType: 'type-1',
        hasLayout: true,
        name: 'Probands/Samples',
        hideInMenu: false,
        displaySidebar: true,
        displayHeader: true,
        isPublic: false,
        completePath: '/dashboard',
        data: undefined,
        icon: SampleSearchIcon,
      },
      {
        path: '/upload-vcf',
        layoutType: 'type-1',
        hasLayout: true,
        name: 'Upload variants (VCF)',
        hideInMenu: false,
        displaySidebar: true,
        displayHeader: true,
        isPublic: false,
        completePath: '/upload-vcf',
        data: undefined,
        icon: FileAddOutlined,
      },
      {
        path: '/samples',
        layoutType: 'type-1',
        hasLayout: true,
        name: 'Sample Detail',
        hideInMenu: true,
        displaySidebar: true,
        displayHeader: true,
        isPublic: false,
        completePath: '/samples/:sampleId',
        data: undefined,
      },
      {
        path: '/running-tasks',
        layoutType: 'type-1',
        hasLayout: true,
        name: 'Task Queue',
        hideInMenu: false,
        displaySidebar: true,
        displayHeader: true,
        isPublic: false,
        completePath: '/running-tasks',
        data: undefined,
        icon: ClockCircleOutlined,
      },
      {
        path: '/variant-workflow',
        layoutType: 'type-1',
        hasLayout: true,
        name: 'Variant Workflow',
        hideInMenu: true,
        displaySidebar: true,
        displayHeader: true,
        isPublic: false,
        completePath: '/variant-workflow/:vid',
        data: undefined,
        icon: HeatMapOutlined,
      },
      {
        path: '/legal',
        layoutType: 'type-1',
        hasLayout: true,
        name: 'Legal Requirements',
        hideInMenu: true,
        displaySidebar: false,
        displayHeader: true,
        isPublic: true,
        completePath: '/legal',
        data: undefined,
      },
      // {
      //   path: '/settings',
      //   element: Settings,
      //   layoutType: 'type-1',
      //   hasLayout: true,
      //   name: 'Settings',
      //   hideInMenu: false,
      //   displaySidebar: true,
      //   displayHeader: true,
      //   isPublic: true,
      //   completePath: '/settings',
      //   data: undefined,
      //   icon: SettingOutlined,
      // },
    ],
    [],
  );

  return { routes };
};
